export class UIDValuesExamplesSceneController {
    hide() {
        this.valuesExamplesSceneContainerDiv.classList.add('hidden');
    }
    show() {
        this.valuesExamplesSceneContainerDiv.classList.remove('hidden');
        this.sidebarController.deactivateAllButtons();
    }
    constructor(sidebarController){
        this.sidebarController = sidebarController;
        this.valuesExamplesSceneContainerDiv = document.getElementById('scene_discord_values_examples_container');
    }
}
